module.exports = __webpack_public_path__ + "static/media/design_guideline@x3_profile.9df087e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/design_guideline@x3_profile.png
// module id = 512
// module chunks = 0